import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/wrappers/Http';
import { ConfigService } from '../config/config.service';
import { of, BehaviorSubject, from } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { PartnerBonus, PartnerBonusType } from 'src/app/interfaces/partner-bonus';
import { PartnerOption } from 'src/app/interfaces/partners';
import { EndPoints } from 'src/app/configs';

@Injectable({
  providedIn: 'root'
})
export class PartnerBonusService {
  bonusesFetched: boolean;
  constructor(private http: HttpService, private configs: ConfigService){}

  selectedRegistrationBonus = new BehaviorSubject<number>(0);
  selectedDepositBonus = new BehaviorSubject<number>(0);
  registrationBonuses = new BehaviorSubject<PartnerBonus[]>([]);
  depositBonuses = new BehaviorSubject<PartnerBonus[]>([]);
  partnerBonusesLoaded = new BehaviorSubject<boolean>(false);
  allPartnerBonuses = new BehaviorSubject<PartnerBonus[]>([]);

  castBonusProd(res: any){
    if(res.strPartnerInfo){
      let {strPartnerInfo, ...rest} = res;
      return {...rest, partnerInfo: JSON.parse(strPartnerInfo)};
    }else {
      return {...res, partnerInfo: []};
    }
  }

  formatPartnerBonusOptions(partnerBonuses: PartnerBonus[]) {
      let options: PartnerOption[] = [];

      partnerBonuses.forEach((bp) => {
        let maxAmount = bp.tbonusPackageCustomizeList[0].packageCustomizeId.dbEarningsCeiling;
        let criteria = bp.tbonusPackageCustomizeList[0].packageCustomizeId.packageRuleCustomizeId;
        let winBonusKey = 'win_bonus'
        let winBonusLimitKey = 'win_bonus_limit'
        switch(bp.type){
          case PartnerBonusType.BONUS_DEPOSIT:
            winBonusKey = 'win_bonus_deposit';
            winBonusLimitKey = 'win_bonus_limit_deposit'
            break;
          case PartnerBonusType.BONUS_REGISTRATION:
            winBonusKey = 'win_bonus_reg';
            winBonusLimitKey = 'win_bonus_limit_reg'
            break;
          default:
            break;
        }
        let subtitle = criteria.dbFlatAmount > 0 && criteria.dbFlatPercentage == 0 ?
                      { key: winBonusKey, amount: criteria.dbFlatAmount} :
                      { key: winBonusLimitKey, amount: maxAmount};

        if(bp.partnerInfo){
          bp.partnerInfo.forEach((p) => {
            options.push({
              title: bp.description,
              partnerName: p.name,
              subtitle,
              value: {id: bp.id.toString(), partnerId: p.id}
            });
          })
        }
      });

      return options;
  }

  getRegistrationBonusOptions(){
    return this.registrationBonuses.asObservable().pipe(map((bonuses) => this.formatPartnerBonusOptions(bonuses)))
  }

  getDepositBonusOptions(){
    return this.depositBonuses.asObservable().pipe(map((bonuses) => this.formatPartnerBonusOptions(bonuses)))
  }

  getPartnerBonuses() {
    let baseUrl = this.configs.PROXIES.userService.replace('v2', 'v1');
    // let baseUrl = 'https://svc2.softtech.test.flexbet-systems.net:14443/mathys-gateway/v2/';
    const api = baseUrl + EndPoints.partnerBonuses;
    return from(this.http.get_no_auth(api, {})).pipe(
      catchError(() => {
        return of([]);
      }),
      map((response) => {
        if (Array.isArray(response)){
          let partnerBonuses: PartnerBonus[] = response.map((r) => this.castBonusProd(r));
          this.depositBonuses.next(
            partnerBonuses.
            filter(b => b.type === PartnerBonusType.BONUS_DEPOSIT).
            filter(b => Array.isArray(b.tbonusPackageCustomizeList) && b.tbonusPackageCustomizeList.length > 0).
            filter(b => ('packageCustomizeId' in b.tbonusPackageCustomizeList[0]))
          );
          this.registrationBonuses.next(
            partnerBonuses.
            filter(b => b.type === PartnerBonusType.BONUS_REGISTRATION).
            filter(b => Array.isArray(b.tbonusPackageCustomizeList) && b.tbonusPackageCustomizeList.length > 0).
            filter(b => ('packageCustomizeId' in b.tbonusPackageCustomizeList[0]))
          );
          this.bonusesFetched = true;
          this.partnerBonusesLoaded.next(true);
          this.allPartnerBonuses.next(partnerBonuses);
          return partnerBonuses;
        }else {
          this.partnerBonusesLoaded.next(false);
        }
        return [];
      }));
  }


}
